<template>
    <div class="gonser-box" :class="[getClasses, {'hide': setVisibility && !isBoxItem, 'smaller': smaller, 'isBasketOverlay': isBasketOverlay}]">
        <div class="gonser-box-inner align-items-center" :class="{'d-md-flex': !column}" v-if="hasTotalItems">
            <div class="gonser-box-column-one" :class="{'mb-5 mb-md-0': !column, 'mb-4': column}">
                <div class="h3 mb-3">
                    <span v-if="!isBasketOverlay && isFree" v-html='$translate("GonserDT::Template.gonserBoxAmountReached")'>
                    </span>
                    <span v-if="isBasketOverlay && isFree" v-html='$translate("GonserDT::Template.gonserBoxAmountReachedBasketItemOverlay")'>
                    </span>
                    <span v-if="!isFree && isBasketOverlay"
                          v-html='$translate("GonserDT::Template.gonserBoxAmountLeftBasketItemOverlay", { diff: getCurrencyString(diff) })'>
                    </span>
                    <span v-if="!isFree && !isBasketOverlay"
                          v-html='$translate("GonserDT::Template.gonserBoxAmountLeft", { diff: getCurrencyString(diff) })'>
                    </span>
                    <svg v-if="isBasketOverlay"
                        @click="openShippingInfo()" 
                        xmlns="http://www.w3.org/2000/svg" 
                        viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                </div>
                <div class="d-flex gonser-progress-bar">
                    <div class="gonser-box-shipping-progress-info position-relative d-flex justify-content-between align-items-center w-100">
                        <div class="gonser-box-shipping-progress-bar bg-success position-absolute h-100"
                            :style="'width: '+ (total*100/limit).toFixed(0) +'%'">
                        </div>
                        <span>
                        <strong>{{ getCurrencyString(total) }}</strong>
                        </span>
                        <span>
                        <strong v-if="!isFree">{{ getCurrencyString(diff) }}</strong>
                        <i v-else class="fa fa-check fa-lg"></i>
                        </span>
                    </div>
                    <lazy-img 
                        v-if="isBasketOverlay && isSmallScreen"
                        picture-class="img-fluid"
                        image-url="https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/gonserbox.png"
                        alt="Gonser-Box">
                    </lazy-img>
                </div>
                
            </div>
            <div v-if="!isBasketOverlay || (isBasketOverlay && !isSmallScreen)" class="gonser-box-column-two">
                <div class="d-sm-flex justify-content-between align-items-center"
                     :class="{'justify-content-md-start justify-content-lg-between': column, 'justify-content-md-center': !column }">
                    <div 
                        v-html='$translate("GonserDT::Template.gonserBoxExplanation", {limit: getCurrencyString(limit)})'>
                    </div>
                    <div class="img-wrapper">
                        <lazy-img picture-class="img-fluid"
                                  image-url="https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/gonserbox.png"
                                  alt="Gonser-Box">
                        </lazy-img>
                    </div>
                </div>
            </div>
            <div v-if="showAdditionalInfo" class="gonser-box-column-three mt-3">
                <a :href="$translate('GonserDT::Template.themeBoxCategoryUrl')"
                   class="btn btn-dark btn-sm d-block d-sm-inline-block mb-3 mb-md-0 mr-sm-3">
                    {{ $translate("GonserDT::Template.gonserBoxShowAllItems") }}
                </a>
                <a v-if="!isCheckout"
                   @click="openShippingInfo()"
                   :title="$translate('Ceres::Template.shippingInfoCosts')"
                   class="btn btn-secondary text-white mb-3 mb-md-0 btn-sm d-block d-sm-inline-block">
                    {{ $translate("GonserDT::Template.generalMoreInfo") }}
                </a>
                <a v-else
                   :href="$translate('GonserDT::Template.uspsFeat1URL')"
                   :title="$translate('Ceres::Template.shippingInfoCosts')"
                   class="btn btn-secondary mb-3 mb-md-0 btn-sm d-block d-sm-inline-block">
                    {{ $translate("GonserDT::Template.generalMoreInfo") }}
                </a>
            </div>
        </div>
        <div v-if="(isShopBuilder && isItem) || (setVisibility && isItem)"
             class="gonser-box-description row flex-column flex-sm-row no-gutters">
            <div class="gonser-box-img col-12 col-sm-4 col-lg-3 align-self-center text-center">
                <lazy-img
                    picture-class="img-fluid"
                    image-url="/layout/gonser_2015_20190704/img/gonserbox.png"></lazy-img>
            </div>
            <div class="gonser-box-text col-12 col-sm-8 col-lg-9 pl-sm-3">
                <p class="headline font-weight-bolder" v-html="$translate('GonserDT::Template.gonserBoxExplainTitle')"></p>
                <p v-html="$translate('GonserDT::Template.gonserBoxExplainText')"></p>
                <div class="btn-wrapper">
                    <a :href="$translate('GonserDT::Template.themeBoxCategoryUrl')"
                       class="btn btn-dark btn-sm d-block d-sm-inline-block mb-3 mb-md-0 mr-sm-3">
                        {{ $translate("GonserDT::Template.gonserBoxShowAllItems") }}
                    </a>
                    <a data-toggle="modal"
                       href="#shippingscosts"
                       :title="$translate('Ceres::Template.shippingInfoCosts')"
                       class="btn btn-secondary btn-sm d-block mb-3 mb-md-0 d-sm-inline-block">
                        {{ $translate("GonserDT::Template.generalMoreInfo") }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ApiService from "../../services/ApiService";
import ModalService from "../../services/ModalService";

export default {
    
    name: "gonser-box",
    
    props: {
        template: String,
        isBoxItem: {
            type: Boolean,
            default: false
        },
        showAdditionalInfo: {
            type: Boolean,
            default: false
        },
        column: {
            type: Boolean,
            default: false
        },
        isItem: {
            type: Boolean,
            default: false
        },
        smaller: {
            type: Boolean,
            default: false
        },
        classes: {
            type: String,
            default: ''
        },
        isShopBuilder: {
            type: Boolean,
            default: false
        },
        isBasketOverlay: {
            type: Boolean,
            default: false
        }
    },
    
    created() {
        this.checkAndAddBoxes();
        
        ApiService.listen("AfterBasketChanged", data => {
            this.items = {};
            this.checkAndAddBoxes();
        });
    },

    mounted() {
        this.updateScreenSize();
        window.addEventListener('resize', this.updateScreenSize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenSize);
    },

    data() {
        return {
            diff        : 0,
            isFree      : false,
            items       : {},
            total       : 0,
            totalItems  : 0,
            boxInBasket : false,
            limit       : App.gonserBoxLimit,
            screenSize: "large"
        };
    },
    
    computed: {
        currency() {
            return this.basket.currency;
        },
        
        shipping() {
            return this.basket.shippingAmount;
        },
        
        setVisibility()
        {
            return this.total === 0 || this.isShopBuilder;
        },
        
        hasTotalItems ()
        {
            return this.totalItems > 0;
        },
        
        lang()
        {
            return App.language !== "de" ? App.language + '/' : "";
        },
        
        getClasses()
        {
            return !this.setVisibility || this.isBoxItem ? this.classes : "";
        },
        
        isCheckout()
        {
            return App.isCheckoutView;
        },
        
        ...mapState({
            basketItems: state => state.basket.items,
            basket: state => state.basket.data
        }),
        isSmallScreen() {
            return this.screenSize === 'small';
        },
        isMediumScreen() {
            return this.screenSize === 'medium';
        },
        isLargeScreen() {
            return this.screenSize === 'large';
        }
    },
    
    methods: {
        checkAndAddBoxes()
        {
            let tmpBoxInBasket = false;
            
            if (this.basketItems && this.basketItems.length > 0)
            {
                for (let basketItem of this.basketItems)
                {
                    if (basketItem.variation != null && basketItem.variation.data.variationProperties)
                    {
                        for (let variationPropertyProperty of basketItem.variation.data.variationProperties)
                        {
                            if (variationPropertyProperty != null)
                            {
                                for (let property of variationPropertyProperty.properties)
                                {
                                    if (property.id === 4 && property.values.value === "1")
                                    {
                                        tmpBoxInBasket = true;
                                        this.addProduct({
                                            "id": basketItem.variation.id,
                                            "price": basketItem.price,
                                            "quantity": basketItem.quantity
                                        });
                                    }
                                }
                            }
                            
                        }
                    }
                }
                this.boxInBasket = tmpBoxInBasket;
            }
            this.updateComponentTotals();
        },
        
        openShippingInfo()
        {
            ModalService.findModal(document.getElementById("shippingscosts")).show();
            document.body.classList.remove("basket-open");
        },
        
        // +++++ INCREMENT
        addProduct( item )
        {
            this.items[item.id] = { "price" : item.price, "quantity": item.quantity };
            this.totalItems = this.totalItems + item.quantity;
        },
        getCurrencyString(value)
        {
            return this.currency + " " + parseFloat(value).toFixed(2);
        },
        updateComponentItems( item )
        {
            if (this.items.hasOwnProperty(item.id))
            {
                this.items[item.id] = { "price" : item.price, "quantity": item.quantity };
            }
            this.updateComponentTotals();
        },
        updateComponentTotals()
        {
            this.total         = 0;
            this.totalItems    = 0;
            
            for (let key in this.items)
            {
                this.total += (this.items[key].quantity*this.items[key].price);
                this.totalItems = this.totalItems + this.items[key].quantity;
            }
            
            this.diff   = parseInt(this.limit) - this.total;
            this.isFree = this.diff <= 0;
            
            this.updateInstances( {
                'diff'       : this.diff,
                'isFree'     : this.isFree,
                'items'      : this.items,
                'total'      : this.total,
                'totalItems' : this.totalItems
            });
        },
        deleteComponentItems(id)
        {
            delete this.items[id];
            this.updateComponentTotals();
        },
        
        updateInstances(options)
        {
            this.diff       = options.diff;
            this.isFree     = options.isFree;
            this.items      = options.items;
            this.total      = options.total;
            this.totalItems = options.totalItems;
        },

        updateScreenSize()
        {
            const width = window.innerWidth;
            if (width < 768) {
                this.screenSize = 'small';
            } else if (width >= 768 && width < 992) {
                this.screenSize = 'medium';
            } else {
                this.screenSize = 'large';
            }
        }
    },
    
    watch:
        {
            basketItems()
            {
                this.checkAndAddBoxes();
            }
        }
}
</script>
